import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: ()=> import ('@/components/homePage/homePage'),
      redirect: '/index',
      children:[{
          path: '/index',
          component: () => import('@/components/homePage/index'),
          name: 'index',
          meta: {
            title: '中国城市出版社官网-首页'
          },
        },{
          path: '/bookList',
          component: () => import('@/components/bookList/bookList'),
          name: 'bookList',
          meta: {
            title: '中国城市出版社官网-图书总目'
          },
        },{
          path: '/newsUpdates',
          component: () => import('@/components/newsUpdates/newsUpdates'),
          name: 'newsUpdates',
          meta: {
            title: '中国城市出版社官网-新闻动态'
          },
        },{
          path: '/knowledgeService',
          component: () => import('@/components/knowledgeService/knowledgeService'),
          name: 'knowledgeService',
          meta: {
            title: '中国城市出版社官网-知识服务'
          },
        },{
          path: '/aboutUs',
          component: () => import('@/components/aboutUs/aboutUs'),
          name: 'aboutUs',
          meta: {
            title: '中国城市出版社官网-关于本社'
          },
        },{
          path: '/newsDetails',
          component: () => import('@/components/newsUpdates/newsDetails'),
          name: 'newsDetails',
          meta: {
            title: '中国城市出版社官网-新闻详情'
          },
        },{
          path: '/contact',
          component: () => import('@/components/contact/contact'),
          name: 'contact',
          meta: {
            title: '中国城市出版社官网-联系我们'
          },
        },{
          path: '/searchResults',
          component: () => import('@/components/searchResults/searchResults'),
          name: 'searchResults',
          meta: {
            title: '中国城市出版社官网-搜索结果'
          },
        },
      ]
    },
    {
      path: '/login',
      component: () => import('@/components/login/login'),
      name: 'Login',
      meta: {
        title: '欢迎登录',
        requireAuth: true,
        jumpAuth: true
      }
    },
    {
      path: '/register',
      component: () => import('@/components/register/register'),
      name: 'register',
      meta: {
        title: '欢迎注册',
        requireAuth: true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js